<template>
  <v-col
    cols="12"
    xs="12"
    sm="8" offset-sm="2"
    md="8" offset-md="2"
    lg="8" offset-lg="2"
    xl="4" offset-xl="4"
  >
    <slot></slot>
  </v-col>
</template>

<script>
export default {
  name: 'MobileCol',
};
</script>
